<template>
  <el-table
    :data="customsTariffNumbers"
    max-height="250"
    style="width: 100%"
    v-loading="loading"
    :default-sort="{prop: 'value', order: 'ascending'}"
  >
    <el-table-column
      prop="value"
      label="Érték"
    />
    <el-table-column
      fixed="right"
      label=""
      width="120"
    >
      <template slot-scope="scope">
        <Actions :customsTariffNumber="scope.row" />
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  import Actions from './Actions'

  export default {

    components: {
      Actions
    },

    computed: {
      customsTariffNumbers() {
        return this.$store.getters['customsTariffNumber/customsTariffNumbers'];
      },

      loading() {
        return this.$store.getters['customsTariffNumber/loading'];
      }
    },

    async mounted() {
      await this.$store.dispatch('customsTariffNumber/fetchAll');
    }
  }
</script>
